import { atom } from 'recoil';
export const modalCheckoutAtom = atom({
    key: 'modalCheckoutAtom',
    default: {
        total: 0,
        items: [],
        plan: 'individual',
        isLoading: true
    }
});
